export default function TopProcedure({ index, item }) {
  const levels = ['Alto', 'Alto', 'Médio', 'Baixo']
  const levelColors = ['text-[#8A6819]', 'text-[#8A6819]', 'text-[#7A5963]', 'text-[#7A7269]']

  return (
    <div className={`grid grid-cols-[34px_minmax(0,1fr)_auto] items-center gap-3 rounded-md p-3 ${index % 2 ? 'bg-[#FBFAF8]' : ''}`}>
      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F3E8CE] text-xs font-bold text-[#8A6819]">
        {index + 1}
      </span>
      <div>
        <p className="text-sm font-bold leading-5 text-[#1A1A1A]">{item.procedure}</p>
        <p className="text-xs font-medium text-[#5A5147]">
          {item.count} atendimento{item.count === 1 ? '' : 's'}
        </p>
      </div>
      <span className={`text-sm font-bold ${levelColors[index] || 'text-[#7A7269]'}`}>
        {levels[index] || 'Baixo'}
      </span>
    </div>
  )
}
